export default __webpack_public_path__ + "static/media/logo.beef9462.svg";